let uniqueKeyIndex = 0;

export const uniqueKey = (prefix = "uk") => {
  uniqueKeyIndex++;
  return `${prefix}-${uniqueKeyIndex}`;
};

const react = {
  uniqueKey,
};

export default react;
